import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";

import './index.css'
export default function Main(){

    const gotToForm = () =>{
        window.scrollTo({
            top:  document.getElementById('contact-form').offsetTop,
            behavior: 'smooth'
        });
    };

    const sendEmail = evt =>{
        evt.preventDefault()
        let body = `Hola estoy interesado en crear mi tienda en Encargamelo. Nombre: ${evt.target.name.value}. Tel: ${evt.target.tel.value}, Empresa: ${evt.target.company.value}`;
        window.open(`mailto:diego.bocanegra.trenado@gmail.com?subject=Nueva%20Tienda&body=${body}`);

    }
    return(
        <>
            <header>
                <div className="header-content">
                    <p>ENCARGAMELO.COM</p>

                    <div className="header-buttons">
                        <Link to={'/La-esperanza'} style={ {textDecoration: 'none'}}><button>Ver Demo</button></Link>
                        <Link to={'/login'} style={ {textDecoration: 'none'}}><button id="btn-login">Iniciar sesión</button></Link>
                    </div>
                </div>
            </header>

            <main>
                <div className="hero">
                    <div className="hero-text">
                        <h1>RECIBE Y AGILIZA PEDIDOS EN TU WHATSAPP</h1>
                        <h2>0% comisión</h2>
                        <p>En tiempos de distanciamiento aprovecha la oportunidad de tener mas clientes utilizando tu propia pagina web para recibir pedidos.</p>
                        <ul className="app-advantages">
                            <li><FontAwesomeIcon icon={ faCheckCircle } /> Pedidos ilimitados</li>
                            <li><FontAwesomeIcon icon={ faCheckCircle } /> Sin comisión por pedido</li>
                            <li><FontAwesomeIcon icon={ faCheckCircle } /> Pagina estética y adaptable</li>
                        </ul>

                        <button className="btn" style={{marginTop: 20}} onClick={ gotToForm }>Crear tienda</button>
                    </div>

                    <div className="hero-images">
                        <img src="./basket.png" alt='Canasta' />
                        <img className="second-img" src="./order.png" alt='Pedido' />
                    </div>
                </div>


                <div className="about">
                    <div className="about-container">
                        <div className="about-img">
                            <img src="./restaurant_menu.png" alt='Menu de restaurante' />
                        </div>

                        <div className="about-text">
                            <h3>CREA TU TIENDA Y MEJORA TU PRESENCIA EN LINEA</h3>
                            <p>Con <strong>Encargamelo</strong> puedes crear tu tienda digital de manera fácil. Empieza a agregar tu menú y datos de tu establecimiento para poder recibir pedidos desde tu <strong>WhatsApp</strong>.</p>
                            <button className="btn" style={{marginTop: 20}} onClick={ gotToForm }>Quiero mi tienda</button>

                        </div>
                    </div>

                </div>


                <div className="contact-container">
                    <h4>CONTACTO</h4>
                    <div className="contact" id='contact-form'>

                        <div className="contact-text">
                            <p>
                                Por favor llena la siguiente información, nosotros nos pondremos en contacto para empezar a crear tu tienda lo mas rápido posible.
                            </p>
                            <p>
                                *Todos los campos son requeridos.
                            </p>
                        </div>

                        <div className="contact-form">
                            <form onSubmit={ sendEmail }>
                                <div className='input-container'>
                                    <label>  
                                        <p>Nombre y Apellido</p>
                                        <input type='text' name='name' placeholder='Nombre y apellido'/>
                                    </label> 
                                </div>

                                <div className='input-container'>
                                    <label>  
                                        <p>Teléfono</p>
                                        <input type='text' name='tel' placeholder='Teléfono'/>
                                    </label> 
                                </div>

                                <div className='input-container'>
                                    <label>  
                                        <p>Nombre de la empresa</p>
                                        <input type='text' name='company' placeholder='Nombre de la Empresa'/>
                                    </label> 
                                </div>

                                <button type="submit" className="form-button">ENVIAR</button>
                            </form>
                        </div>
                    </div>
                </div>
            </main>

            <footer>
                <p>
                    © Encargamelo. 2021. Todos los derechos reservados.
                </p>
            </footer>
        </>
    )
}